import { render, staticRenderFns } from "./ListBloq.vue?vue&type=template&id=612a5e55"
import script from "./ListBloq.vue?vue&type=script&lang=js"
export * from "./ListBloq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports